import { Building2 } from "lucide-react";
import { SidebarMenuButton } from "~/components/ui/sidebar";
import type { AgencyBrand } from "~/context/AuthContext";

function logoDevUrl(website: string | null): string | null {
  if (!website) return null;
  const host = website
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .split("/")[0];
  if (!host) return null;
  return `https://img.logo.dev/${host}?token=${
    import.meta.env.VITE_LOGO_DOT_DEV_PUBLISHABLE_API_KEY
  }`;
}

function AgencySquareMark({ agency }: { agency: AgencyBrand }) {
  const src = logoDevUrl(agency.website);
  if (!src) {
    return (
      <div className="size-8 rounded-lg bg-orange-500 text-white flex items-center justify-center shrink-0">
        <Building2 className="size-4" />
      </div>
    );
  }

  const host = agency.website
    ?.replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .split("/")[0];

  return (
    <img
      src={src}
      alt=""
      className="size-8 rounded-lg shrink-0 bg-sidebar-accent"
      onError={(event) => {
        event.currentTarget.onerror = null;
        event.currentTarget.src = `https://www.google.com/s2/favicons?domain=${host}&sz=64`;
      }}
    />
  );
}

export default function AgencySidebarBrand({
  agency,
  sidebarOpen,
  onClick,
  showAgencyLabel = true,
}: {
  agency: AgencyBrand;
  sidebarOpen: boolean;
  onClick: () => void;
  showAgencyLabel?: boolean;
}) {
  const uploaded = agency.logo_url;

  return (
    <SidebarMenuButton
      size="lg"
      className="cursor-pointer"
      onClick={onClick}
      tooltip={agency.name}
    >
      {uploaded ? (
        <img
          src={uploaded}
          alt={agency.name}
          className={
            sidebarOpen
              ? "h-8 w-auto max-w-[10rem] object-contain object-left shrink-0"
              : "size-8 rounded-md object-cover object-left shrink-0"
          }
        />
      ) : (
        <>
          <AgencySquareMark agency={agency} />
          {sidebarOpen ? (
            <div className="grid flex-1 text-left text-sm leading-tight min-w-0">
              <span className="truncate font-semibold">{agency.name}</span>
              {showAgencyLabel && (
                <span className="truncate text-xs text-muted-foreground">
                  Agency
                </span>
              )}
            </div>
          ) : null}
        </>
      )}
    </SidebarMenuButton>
  );
}
